import React from 'react'

export default function NominalGDPGrowthRates() {
  return (
    /// TODO 
    <div>TODO: NominalGDPGrowthRates</div>
  )
}
